import React, { ReactNode, Component } from 'react';
import './Icon.scss';

interface IconProps {
  icon: string;
  className?: string;
}

interface IconState {
  icon?: (className: string) => ReactNode;
}

function IconHome(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M9.6,22.2V15h4.8v7.2h6V12.6H24L12,1.8,0,12.6H3.6v9.6Z" /></svg>
  );
}

function IconMenu(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0z" fill="none" /><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" /></svg>
  );
}

function IconSearch(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0z" fill="none" /><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>
  );
}

function IconClients(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M21 5h2v14h-2zm-4 0h2v14h-2zm-3 0H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H3V7h10v10z" /><circle cx="8" cy="9.94" r="1.95" /><path d="M11.89 15.35c0-1.3-2.59-1.95-3.89-1.95s-3.89.65-3.89 1.95V16h7.78v-.65z" /></svg>
  );
}

function IconDocument(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" /></svg>
  );
}

function IconChat(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z" /></svg>
  );
}

function IconBergop(className: string): ReactNode {
  return (
    // tslint:disable-next-line: max-line-length
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g style={{ opacity: 0.4 }}><path d="M2.54,11.17a.85.85,0,0,0-.19.58v.33a.78.78,0,0,0,.17.51.57.57,0,0,0,.46.2.59.59,0,0,0,.52-.26,1.2,1.2,0,0,0,.19-.73,1,1,0,0,0-.17-.62A.59.59,0,0,0,3,11,.66.66,0,0,0,2.54,11.17Z" /><path d="M7.86,19.12a3.17,3.17,0,0,1-3.34-3.31V12.65a1.58,1.58,0,0,1-.21.41,1.26,1.26,0,0,1-1,.49,1,1,0,0,1-.9-.45h0v.37h-1V8.74h1v2h0a1.16,1.16,0,0,1,1-.56,1.13,1.13,0,0,1,1,.42,1.2,1.2,0,0,1,.16.32V5.24H3a3.29,3.29,0,0,0-3,3c0,4.39,0,5.05,0,9.44,0,.22,0,.89,0,1.43C0,20.74,1.52,24,4.51,24c4.22,0,7,0,11.22,0a2.67,2.67,0,0,0,2.36-1.49,5.52,5.52,0,0,0,.66-3.37Z" style={{ opacity: 0.7 }} /></g><path d="M12.85,11a.59.59,0,0,0-.51.26,1.16,1.16,0,0,0-.19.72,1,1,0,0,0,.18.63.57.57,0,0,0,.49.23.62.62,0,0,0,.49-.23,1,1,0,0,0,.19-.62v-.26a.76.76,0,0,0-.18-.51A.57.57,0,0,0,12.85,11Z" /><path d="M6.74,10.86a.53.53,0,0,0-.41.2.81.81,0,0,0-.21.49H7.3C7.3,11.09,7.11,10.86,6.74,10.86Z" /><path d="M24,12.81c0-3,0-6,0-9A3.73,3.73,0,0,0,20.18,0c-4,0-8,.05-11.95,0A3.58,3.58,0,0,0,4.52,3.68c0,.52,0,1,0,1.56,3.63,0,7.26,0,10.89,0a3,3,0,0,1,2.77,1.64,3.76,3.76,0,0,1,.58,2.19c0,.69,0,1.38,0,2.08v8c.75,0,1.5,0,2.25,0a2.43,2.43,0,0,0,1-.2,3.5,3.5,0,0,0,2-3A21.63,21.63,0,0,0,24,12.81Zm-1.83.25a1.26,1.26,0,0,1-1.05.49,1,1,0,0,1-.88-.45h0v1.84h-1V10.28h1v.48h0a1.16,1.16,0,0,1,1-.56,1.17,1.17,0,0,1,1,.42,1.86,1.86,0,0,1,.34,1.16A1.91,1.91,0,0,1,22.13,13.06Z" style={{ opacity: 0.5 }} /><path d="M20.86,11a.61.61,0,0,0-.49.23.91.91,0,0,0-.2.61V12a.8.8,0,0,0,.18.54.57.57,0,0,0,.46.21.59.59,0,0,0,.52-.26,1.27,1.27,0,0,0,.19-.73C21.52,11.23,21.3,11,20.86,11Z" style={{ opacity: 0.5 }} /><path d="M18.76,9.06a3.76,3.76,0,0,0-.58-2.19,3,3,0,0,0-2.77-1.64c-3.63,0-7.26,0-10.89,0v5.7a2.17,2.17,0,0,1,.16.84,2.33,2.33,0,0,1-.16.87v3.16a3.17,3.17,0,0,0,3.34,3.31H18.75v-8C18.75,10.44,18.73,9.75,18.76,9.06ZM8.21,12.15H6.13c0,.47.32.7.87.7a1.71,1.71,0,0,0,.93-.25v.71a2.42,2.42,0,0,1-1.15.24,1.59,1.59,0,0,1-1.2-.43,1.62,1.62,0,0,1-.43-1.2,1.7,1.7,0,0,1,.46-1.26,1.55,1.55,0,0,1,1.14-.46,1.43,1.43,0,0,1,1.08.41,1.62,1.62,0,0,1,.38,1.13Zm2.67-1a.91.91,0,0,0-.41-.09.62.62,0,0,0-.51.23,1,1,0,0,0-.18.64v1.53h-1V10.28h1v.59h0a.86.86,0,0,1,.85-.65.55.55,0,0,1,.24,0Zm3.59,1.95A1.8,1.8,0,0,1,14,14.48a2.08,2.08,0,0,1-1.49.49,2.44,2.44,0,0,1-1-.18V14a2,2,0,0,0,1,.28,1,1,0,0,0,.77-.26,1,1,0,0,0,.28-.72V13h0a1.08,1.08,0,0,1-1,.54,1.19,1.19,0,0,1-1-.43A1.75,1.75,0,0,1,11.15,12a1.93,1.93,0,0,1,.4-1.29,1.33,1.33,0,0,1,1-.47,1,1,0,0,1,.87.45h0v-.37h1Zm2.31.41a1.68,1.68,0,1,1,1.68-1.68A1.68,1.68,0,0,1,16.78,13.52Z" /></svg>
  );
}

function IconTherapieland(className: string): ReactNode {
  return (
    // tslint:disable-next-line: max-line-length
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 192.07 198.94"><g id="Laag_2" data-name="Laag 2"><path d="M212.92,197.57a16.56,16.56,0,0,0-7.53,1.8L188.15,173.9a29.81,29.81,0,0,0-7.63-51.33l18.24-60.19a15.6,15.6,0,0,0,2.38.19,15.32,15.32,0,1,0-6.4-1.41L176.5,121.35a29.4,29.4,0,0,0-6.67-.76,29.81,29.81,0,0,0-29.77,28.27H57a9.85,9.85,0,1,0,0,4.2h83.17a29.8,29.8,0,0,0,44.52,23.18l17.25,25.49a16.66,16.66,0,1,0,11-4.16Z" transform="translate(-37.51 -31.95)" /></g></svg>
  );
}

function IconZaurus(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M12.4,24a36.25,36.25,0,0,1-5.08-.23A6.64,6.64,0,0,1,4.6,23c-.91-.51-.46-1.34-.41-2A8.82,8.82,0,0,1,6.11,16.3a7.47,7.47,0,0,1,1.22-1.16c.28-.24.57-.1.81.11,1.67,1.53,3.71,1.7,5.8,1.43a6,6,0,0,0,3-1.55c.34-.29.58-.26.94,0A8.23,8.23,0,0,1,20.8,20c.13.59.16,1.18.27,1.76.18,1-.42,1.37-1.17,1.6a10.25,10.25,0,0,1-2.19.44A43.64,43.64,0,0,1,12.4,24Z" /><path d="M19,8a6.5,6.5,0,0,1-4.27,6.43,6.5,6.5,0,0,1-5.94-.52c-.32-.19-.89-.33-.78-.73s.67-.11,1-.1a9.87,9.87,0,0,0,6-1.77,8.87,8.87,0,0,0,3.07-4.06c.07-.19.16-.38.25-.57l.39-.82a5.67,5.67,0,0,1,.29,1A9.12,9.12,0,0,1,19,8Z" /><path d="M17.56,3A7.42,7.42,0,0,0,14.83.82,6,6,0,0,0,12.35,0,7.1,7.1,0,0,0,6.43,2.68a6.26,6.26,0,0,0-1.5,5.19,1.91,1.91,0,0,1-.94,2c-.32.27-.75.37-1,.75-.11.16-.17.27,0,.39a1.29,1.29,0,0,0,1.28.28c1.06-.51.92-.68,1.78-.12a4.91,4.91,0,0,0,2.44.63,10,10,0,0,0,5.8-2.06,8.61,8.61,0,0,0,3.2-4.48C17.72,4.51,18,3.68,17.56,3ZM8.76,7.16c-.39,0-.59-.19-.55-.44,0-.55.15-.85.61-.84a.57.57,0,0,1,.61.64A.61.61,0,0,1,8.76,7.16Zm2.63,0a.63.63,0,0,1-.69-.67c0-.42.23-.64.75-.64s.53.2.52.62S11.88,7.18,11.39,7.18Zm2.39-.07c-.36,0-.67-.17-.67-.62a.56.56,0,0,1,.62-.61.59.59,0,0,1,.68.6C14.38,6.9,14.18,7.13,13.78,7.11Z" /></svg>
  );
}

function IconZivver(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M1.64,14.37V3.07A2.76,2.76,0,0,1,4.19.33C6.1.18,8.91,0,12,0s5.89.17,7.8.33a2.77,2.77,0,0,1,2.56,2.75V14.37C22.36,19.84,12,24,12,24S1.64,19.84,1.64,14.37ZM15.46,9.86l.12-2.64,1.71-1.86,3.25-1.13L17,4.69l-1.21-.32-2.36.52L12.4,6.79,8.23,5.39h-5L7,7.22,9.24,9.47l1.56.74-.5,3v2.18l.27,2.68.82,1.44.35-3.92.78-3.1Z" /></svg>
  );
}

function IconSort(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0z" fill="none" /><path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" /></svg>
  );
}

function IconFilter(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24m0,24H0" fill="none"/><path d="M4.25,5.61,10,13v6a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V13s3.72-4.8,5.74-7.39A1,1,0,0,0,19,4H5A1,1,0,0,0,4.25,5.61Z"/><path d="M0,0H24V24H0Z" fill="none"/></svg>
  );
}

function IconAgenda(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z" /></svg>
  );
}

function IconOpenIn(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" /></svg>
  );
}

function IconTool(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31 1.08 1.08 1.49 2.57 1.24 3.96-.12.71-.42 1.37-.88 1.96l9.45 9.45-.88.89z" /></svg>
  );
}

function IconGauge(className: string): ReactNode {
  return (
    // tslint:disable-next-line: max-line-length
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none"/><path id="Icon_Shape" data-name="Icon Shape" d="M20.38,8.57l-1.23,1.85A8,8,0,0,1,18.93,18H5.07A8,8,0,0,1,15.58,6.85l1.85-1.23A10,10,0,0,0,3.35,19a2,2,0,0,0,1.72,1H18.92a2,2,0,0,0,1.74-1,10,10,0,0,0-.27-10.44Zm-9.79,6.84a2,2,0,0,0,2.83,0h0l5.66-8.49-8.49,5.66a2,2,0,0,0,0,2.83Z"/></svg>
  );
}

function IconThermometer(className: string): ReactNode {
  return (
    // tslint:disable-next-line: max-line-length
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none"/><path id="Icon_Shape" data-name="Icon Shape" d="M15,13V5A3,3,0,0,0,9,5v8a5,5,0,1,0,6,0Zm-4-2V5a1,1,0,0,1,2,0V6H12V7h1V9H12v1h1v1Z"/></svg>
  );
}

function IconEdit(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" /></svg>
  );
}

function IconChart(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z" /></svg>
  );
}

function IconLoop(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" /></svg>
  );
}

function IconCopy(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15,20H5V7A1,1,0,0,0,4,6H4A1,1,0,0,0,3,7V20a2,2,0,0,0,2,2H15a1,1,0,0,0,1-1h0A1,1,0,0,0,15,20Zm5-4V4a2,2,0,0,0-2-2H9A2,2,0,0,0,7,4V16a2,2,0,0,0,2,2h9A2,2,0,0,0,20,16Zm-2,0H9V4h9Z"/></svg>
  );
}

function IconSwitch(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><g><rect fill="none" height="24" width="24" /></g><g><g /><g><path d="M22,8l-4-4v3H3v2h15v3L22,8z" /><path d="M2,16l4,4v-3h15v-2H6v-3L2,16z" /></g></g></svg>
  );
}

function IconUser(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z" /></svg>
  );
}

function IconGroup(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" transform="translate(0 0)" fill="none" /><path d="M16,11a3,3,0,1,0-3-3A3,3,0,0,0,16,11ZM8,11A3,3,0,1,0,5,8,3,3,0,0,0,8,11Zm0,2c-2.33,0-7,1.17-7,3.5V19H15V16.5C15,14.17,10.33,13,8,13Zm8,0c-.29,0-.62,0-1,.05a4.22,4.22,0,0,1,2,3.45V19h6V16.5C23,14.17,18.33,13,16,13Z" transform="translate(0 0)" /></svg>
  );
}

function IconBack(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87" /><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" /></svg>
  );
}

function IconFile(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z" /></svg>
  );
}

function IconDelete(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none"/><path d="M6,19a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V7H6ZM19,4H15.5l-1-1h-5l-1,1H5V6H19Z"/></svg>
  );
}

function IconAddPerson(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z" /></svg>
  );
}

function IconDropdown(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" /></svg>
  );
}

function IconSettings(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M6.21 13.97l1.2 2.07c.08.13.23.18.37.13l1.49-.6c.31.24.64.44 1.01.59l.22 1.59c.03.14.15.25.3.25h2.4c.15 0 .27-.11.3-.26l.22-1.59c.36-.15.7-.35 1.01-.59l1.49.6c.14.05.29 0 .37-.13l1.2-2.07c.08-.13.04-.29-.07-.39l-1.27-.99c.03-.19.04-.39.04-.58 0-.2-.02-.39-.04-.59l1.27-.99c.11-.09.15-.26.07-.39l-1.2-2.07c-.08-.13-.23-.18-.37-.13l-1.49.6c-.31-.24-.64-.44-1.01-.59l-.22-1.59c-.03-.14-.15-.25-.3-.25h-2.4c-.15 0-.27.11-.3.26l-.22 1.59c-.36.15-.71.34-1.01.58l-1.49-.6c-.14-.05-.29 0-.37.13l-1.2 2.07c-.08.13-.04.29.07.39l1.27.99c-.03.2-.05.39-.05.59 0 .2.02.39.04.59l-1.27.99c-.11.1-.14.26-.06.39zM12 10.29c.94 0 1.71.77 1.71 1.71s-.77 1.71-1.71 1.71-1.71-.77-1.71-1.71.77-1.71 1.71-1.71zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm0 16H5V5h14v14z" /></svg>
  );
}

function IconLogOut(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none" /><path d="M17,7,15.59,8.41,18.17,11H8v2H18.17l-2.58,2.58L17,17l5-5ZM4,5h8V3H4A2,2,0,0,0,2,5V19a2,2,0,0,0,2,2h8V19H4Z" /></svg>
  );
}

function IconDown(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 11 9">
      <path d="M4.647,1.4a1,1,0,0,1,1.707,0L10.07,7.479A1,1,0,0,1,9.217,9H1.783A1,1,0,0,1,.93,7.479Z" transform="translate(11 9) rotate(180)" />
    </svg>
  );
}

function IconEmail(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none" /><path d="M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6A2,2,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z" /></svg>
  );
}

function IconVideoCam(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none" /><path d="M17,10.5V7a1,1,0,0,0-1-1H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l4,4V6.5Z" /></svg>
  );
}

function IconParticipants(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><rect width="24" height="24" fill="none"/><path d="M12,12.75a10.61,10.61,0,0,1,4.24.9A3,3,0,0,1,18,16.38V18H6V16.39a3,3,0,0,1,1.76-2.73A10.44,10.44,0,0,1,12,12.75ZM4,13a2,2,0,1,0-2-2A2,2,0,0,0,4,13Zm1.13,1.1A7,7,0,0,0,4,14a7,7,0,0,0-2.78.58A2,2,0,0,0,0,16.43V18H4.5V16.39A4.5,4.5,0,0,1,5.13,14.1ZM20,13a2,2,0,1,0-2-2A2,2,0,0,0,20,13Zm4,3.43a2,2,0,0,0-1.22-1.85,6.8,6.8,0,0,0-3.91-.48,4.5,4.5,0,0,1,.63,2.29V18H24ZM12,6A3,3,0,1,1,9,9,3,3,0,0,1,12,6Z"/></svg>
  );
}

function IconCareweb(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none"/><path d="M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8Zm2,16H8V16h8Zm0-4H8V12h8ZM13,9V3.5L18.5,9Z"/></svg>
  );
}

function IconAllPersons(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" transform="translate(0 0)" fill="none"/><path d="M16,11a3,3,0,1,0-3-3A3,3,0,0,0,16,11ZM8,11A3,3,0,1,0,5,8,3,3,0,0,0,8,11Zm0,2c-2.33,0-7,1.17-7,3.5V19H15V16.5C15,14.17,10.33,13,8,13Zm8,0c-.29,0-.62,0-1,.05a4.22,4.22,0,0,1,2,3.45V19h6V16.5C23,14.17,18.33,13,16,13Z" transform="translate(0 0)"/></svg>
  );
}

function IconAdd(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none"/><path d="M19,13H13v6H11V13H5V11h6V5h2v6h6Z"/></svg>
  );
}

function IconAdminGroup(className: string): ReactNode {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 24 24" width="1em"><path d="M0,0H24V24H0Z" fill="none"/><circle cx="10" cy="8" r="4"/><path d="M10.67,13,10,13a12.88,12.88,0,0,0-6.61,1.82A2.92,2.92,0,0,0,2,17.35V20h9.26A7,7,0,0,1,10,16,7.07,7.07,0,0,1,10.67,13Z"/><path d="M20.75,16a4.34,4.34,0,0,0-.06-.63l1.14-1-1-1.73-1.45.49a3.65,3.65,0,0,0-1.08-.63L18,11H16l-.3,1.49a3.65,3.65,0,0,0-1.08.63l-1.45-.49-1,1.73,1.14,1a4.34,4.34,0,0,0-.06.63,4.34,4.34,0,0,0,.06.63l-1.14,1,1,1.73,1.45-.49a3.65,3.65,0,0,0,1.08.63L16,21h2l.3-1.49a3.65,3.65,0,0,0,1.08-.63l1.45.49,1-1.73-1.14-1A4.34,4.34,0,0,0,20.75,16ZM17,18a2,2,0,1,1,2-2A2,2,0,0,1,17,18Z"/></svg>
  );
}

export class Icon extends Component<IconProps, IconState> {
  private static readonly iconMap: { [key: string]: (className: string) => ReactNode } = {
    home: IconHome,
    menu: IconMenu,
    search: IconSearch,
    clients: IconClients,
    document: IconDocument,
    chat: IconChat,
    bergop: IconBergop,
    therapieland: IconTherapieland,
    zaurus: IconZaurus,
    zivver: IconZivver,
    sort: IconSort,
    filter: IconFilter,
    agenda: IconAgenda,
    openIn: IconOpenIn,
    tool: IconTool,
    gauge: IconGauge,
    thermometer: IconThermometer,
    edit: IconEdit,
    chart: IconChart,
    loop: IconLoop,
    copy: IconCopy,
    switch: IconSwitch,
    user: IconUser,
    group: IconGroup,
    back: IconBack,
    file: IconFile,
    delete: IconDelete,
    addPerson: IconAddPerson,
    dropdown: IconDropdown,
    settings: IconSettings,
    logout: IconLogOut,
    down: IconDown,
    email: IconEmail,
    videocam: IconVideoCam,
    participants: IconParticipants,
    careweb: IconCareweb,
    allpersons: IconAllPersons,
    add: IconAdd,
    adminGroup: IconAdminGroup,
  };

  constructor(props: IconProps) {
    super(props);
    this.state = {
      icon: Icon.iconMap[props.icon]
    };
  }

  componentDidUpdate(): void {
    const newIcon = Icon.iconMap[this.props.icon];
    if (newIcon !== this.state.icon) {
      this.setState({ icon: newIcon });
    }
  }

  render(): ReactNode {
    const { icon } = this.state;
    const { className } = this.props;
    const fullClassName = `icon ${className ? className : ''}`;
    return (
      <>
        {icon && icon(fullClassName)}
      </>
    );
  }
}
